module.exports = __webpack_public_path__ + "static/img/2020.9c5eeb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2020.png
// module id = X3ey
// module chunks = 1